export const initialState = {
    data: {},
    isFullValue: false
  };
  
  const detailEvaluationReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_DATA_PERFORMANCE_EVALUATION":
        return {
          ...state,
          data: action.data,
          isFullValue: action.isFullValue,
        };
      default:
        return state;
    }
  };
  
  export default detailEvaluationReducer;
  